import { styled } from '@mui/material/styles';

const { MOBILE_BREAKPOINT } = require('@src/styles/config');

export const StyledReferralIntroSection = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    align-items: flex-start;
    gap: 8px;
  }

  .intro-content {
    flex: 1;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px 16px;
  }

  .intro-title-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 1 auto;
    min-width: 280px;
    max-width: 380px;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      flex-basis: 100%;
      min-width: 0;
      max-width: none;
    }
  }

  .intro-title {
    font-size: 48px;
    font-weight: 700;
    line-height: 56px;
    letter-spacing: -0.4px;
    background: linear-gradient(
      101deg,
      #2506f9 -15.17%,
      #f1414d 77.34%,
      #f48b71 96.99%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      font-size: 20px;
      line-height: 28px;
    }
  }

  .intro-description {
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
    letter-spacing: -0.4px;
    background: linear-gradient(
      101deg,
      #2506f9 -15.17%,
      #f1414d 77.34%,
      #f48b71 96.99%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  .intro-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
  }

  .referral-img {
    max-width: 160px;
    height: auto;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      max-width: 100px;
    }
  }
`;
